import { render } from "./Qualificationcou.vue?vue&type=template&id=2d819bba"
import script from "./Qualificationcou.vue?vue&type=script&lang=js"
export * from "./Qualificationcou.vue?vue&type=script&lang=js"

import "./Qualificationcou.vue?vue&type=style&index=0&id=2d819bba&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__